import Button from "@/components/ui/Button";
import React from 'react'
export default function ProductErrorQuantity({onClick} : {onClick?: ()=>void}) {
  return (
    <div className=" flex justify-end flex-col gap-2">
    <p className=" text-center font-semibold">Có xự cố gián đoạn trong giây lát vui lòng tải lại</p>
    <Button onClick={onClick}>Tải lại</Button>
  </div>
  )
}
